import {theme} from "./Tema";

export const VALORENVIOGRATIS = 350000

export const ESTADOSPRODUCTO = [
    {
        nombre: 'Publicado',
        color: theme.palette.primary.main
    },
    {
        nombre: 'Archivada',
        color: theme.palette.secondary.main
    },
]


export const ESTADOSMAYORISTAS = [
    {
        nombre: 'Nuevo',
        color: '#EA3224'
    },
    {
        nombre: 'Seguimiento',
        color: '#232323'
    },
    {
        nombre: 'Archivado',
        color: '#5c5c5c'
    },
]


export const ESTADOSSOLICITUDES = [
    {
        nombre: 'Nuevo',
        color: '#EA3224'
    },
    {
        nombre: 'En Contacto',
        color: '#232323'
    },
    {
        nombre: 'Seguimiento',
        color: '#FFB100'
    },
    {
        nombre: 'Enviado',
        color: '#4a552b'
    },
    {
        nombre: 'Archivado',
        color: '#5c5c5c'
    },
]







export const ESTADOSUSUARIOS = [
    {
        nombre: 'Solicitante',
        color: theme.palette.primary.main
    },
    {
        nombre: 'Admin',
        color: theme.palette.secondary.main
    },
    {
        nombre: 'Suspendido',
        color: theme.palette.info.main
    },
]
